import { cn, type Children } from '@/utils/react-ext'
import type React from 'react'
import { LoadingSpinner } from '../states/LoadingSpinner'

export const CVButton: React.FC<Children & { isLoading?: boolean, className?: string, disabled?: boolean, onClick?: () => void }> = ({
	children, className, disabled, onClick, isLoading
}) => {
	return <button
		type="button"
		className={cn('cv-btn', className)}
		disabled={disabled}
		onClick={onClick}
	>
		{ isLoading ? <LoadingSpinner className='size-4' /> : children }
	</button>
}